var _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSportsThumbnailContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-podium",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 62C38.2386 62 36 64.2386 36 67V78H17C14.2386 78 12 80.2386 12 83V101H52H92V83C92 80.2386 89.7614 78 87 78H68V67C68 64.2386 65.7614 62 63 62H41Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6091 11.6842C35.91 11.6842 35.3433 12.2509 35.3433 12.95C35.3433 13.6491 35.91 14.2159 36.6091 14.2159H38.8883V16.4443H32.8101C32.5916 16.4443 32.3823 16.5326 32.2298 16.6891C32.0773 16.8457 31.9945 17.0572 32.0003 17.2757C32.0445 18.957 32.4253 21.5058 33.4485 23.7142C34.4481 25.8717 36.1492 27.8678 38.8883 28.1708V30.9251C38.8883 30.9251 41.0534 37.6173 48.5076 39.2001V48.6047L41.1478 51.6712C40.3931 51.9857 39.9015 52.7231 39.9015 53.5407V59.7856C39.9015 60.9041 40.8082 61.8109 41.9268 61.8109H62.1802C63.2988 61.8109 64.2055 60.9041 64.2055 59.7856V53.5407C64.2055 52.7231 63.7139 51.9857 62.9592 51.6712L55.0899 48.3924V39.2006C62.5458 37.6185 64.7114 30.9251 64.7114 30.9251V28.1704C67.4572 27.858 69.1545 25.8089 70.1495 23.6077C71.1704 21.3492 71.5505 18.7418 71.5945 17.0226C71.6001 16.8042 71.5173 16.5928 71.3648 16.4363C71.2123 16.2799 71.0031 16.1917 70.7847 16.1917H64.7114V14.2159H67.4956C68.1947 14.2159 68.7614 13.6491 68.7614 12.95C68.7614 12.2509 68.1947 11.6842 67.4956 11.6842L36.6091 11.6842ZM38.8883 26.5368V18.0645H33.6678C33.7943 19.5303 34.1655 21.4075 34.9186 23.0331C35.7766 24.8848 37.0476 26.2569 38.8883 26.5368ZM68.673 22.9403C67.8121 24.8449 66.5406 26.2468 64.7114 26.5355V17.8119H69.9288C69.8039 19.3214 69.432 21.2613 68.673 22.9403Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-trophy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6091 11.6842C35.91 11.6842 35.3433 12.2509 35.3433 12.95C35.3433 13.6491 35.91 14.2159 36.6091 14.2159H38.8883V16.4443H32.8101C32.5916 16.4443 32.3823 16.5326 32.2298 16.6891C32.0773 16.8457 31.9945 17.0572 32.0003 17.2757C32.0445 18.957 32.4253 21.5058 33.4485 23.7142C34.4481 25.8717 36.1492 27.8678 38.8883 28.1708V30.9251C38.8883 30.9251 41.0534 37.6173 48.5076 39.2001V48.6047L41.1478 51.6712C40.3931 51.9857 39.9015 52.7231 39.9015 53.5407V59.7856C39.9015 60.9041 40.8082 61.8109 41.9268 61.8109H62.1802C63.2988 61.8109 64.2055 60.9041 64.2055 59.7856V53.5407C64.2055 52.7231 63.7139 51.9857 62.9592 51.6712L55.0899 48.3924V39.2006C62.5458 37.6185 64.7114 30.9251 64.7114 30.9251V28.1704C67.4572 27.858 69.1545 25.8089 70.1495 23.6077C71.1704 21.3492 71.5505 18.7418 71.5945 17.0226C71.6001 16.8042 71.5173 16.5928 71.3648 16.4363C71.2123 16.2799 71.0031 16.1917 70.7847 16.1917H64.7114V14.2159H67.4956C68.1947 14.2159 68.7614 13.6491 68.7614 12.95C68.7614 12.2509 68.1947 11.6842 67.4956 11.6842L36.6091 11.6842ZM38.8883 26.5368V18.0645H33.6678C33.7943 19.5303 34.1655 21.4075 34.9186 23.0331C35.7766 24.8848 37.0476 26.2569 38.8883 26.5368ZM68.673 22.9403C67.8121 24.8449 66.5406 26.2468 64.7114 26.5355V17.8119H69.9288C69.8039 19.3214 69.432 21.2613 68.673 22.9403Z",
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-trophy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9887 11.6851V29.9134C47.3262 31.348 48.6596 34.4198 51.2925 35.2299V50.1668C49.2672 51.2638 45.2165 53.6605 45.2165 54.4706V61.8118H41.9243C40.8058 61.8118 39.899 60.905 39.899 59.7864V53.5416C39.899 52.724 40.3906 51.9865 41.1454 51.6721L48.5076 48.6045V39.2015C41.0514 37.6196 38.8858 30.9259 38.8858 30.9259V28.1714C36.1482 27.8674 34.4478 25.8719 33.4485 23.7151C32.4253 21.5067 32.0445 18.9578 32.0003 17.2765C31.9945 17.0581 32.0773 16.8465 32.2298 16.69C32.3823 16.5334 32.5916 16.4451 32.8101 16.4451H38.8858V14.2167H36.6091C35.91 14.2167 35.3433 13.65 35.3433 12.9509C35.3433 12.2518 35.91 11.6851 36.6091 11.6851H46.9887ZM38.8858 18.0654V26.5373C37.0465 26.2565 35.7762 24.8848 34.9186 23.0339C34.1655 21.4084 33.7943 19.5312 33.6678 18.0654H38.8858Z",
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-medal-ribbon",
    x: 54.4902,
    y: 10.5,
    width: 7.03224,
    height: 14.8742,
    rx: 0.982572,
    fill: "white",
    stroke: "#1E1E1E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-medal-ribbon-stripe",
    x: 56.8008,
    y: 11,
    width: 2.4129,
    height: 13.8742,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-medal",
    d: "M58.9408 19.4974C58.6466 18.5921 57.3659 18.5921 57.0718 19.4974L56.0178 22.7412L52.6071 22.7412C51.6552 22.7412 51.2595 23.9592 52.0295 24.5187L54.7889 26.5235L53.7349 29.7673C53.4408 30.6725 54.4769 31.4253 55.2469 30.8658L58.0063 28.861L60.7656 30.8658C61.5357 31.4253 62.5718 30.6725 62.2776 29.7673L61.2237 26.5235L63.983 24.5187C64.7531 23.9592 64.3573 22.7412 63.4055 22.7412L59.9947 22.7412L58.9408 19.4974Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 52.5,
    cy: 70.5,
    r: 3.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 23.5,
    cy: 87.5,
    r: 3.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 77.5,
    cy: 87.5,
    r: 3.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 70.5,
    cy: 87.5,
    r: 3.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 30.5,
    cy: 87.5,
    r: 3.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 84.5,
    cy: 87.5,
    r: 3.5,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSportsThumbnailContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SportsThumbnailContrast.4fd7812593d3f632528cc66ee897e8e2.svg";